;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "ConfirmVerification",
  props: {
    title: {
      type: String,
      default: "Enter Verification Code"
    },
    subtitle: {
      type: String,
      default: "Check your banking app or card statement for a charge from eCitizen."
    },
    inputLabel: {
      type: String,
      default: "Enter the EXACT Code:"
    },
    errorTitle: {
      type: String,
      default: "Verification Unsuccessful"
    },
    errorMessage: {
      type: String,
      default: "The code you entered doesn't match our verification code."
    },
    successTitle: {
      type: String,
      default: "Verification Successful!"
    },
    successSubtitle: {
      type: String,
      default: "You've verified card ownership"
    },
    verifyText: {
      type: String,
      default: "Verify"
    },
    comeBackLaterText: {
      type: String,
      default: "Come back later"
    },
    tipsTitle: {
      type: String,
      default: "Tips for locating the charge:"
    },
    pendingVerification: {
      type: String
    },
    tips: {
      type: Array,
      default: function _default() {
        return ["A small random amount between USD 0.01 and USD 0.99 will be charged to your card.", "Open your banking app or statement when you receive the  notification of this charge.", "Find the charge and note the 3-character code that appears immediately before the merchant name “ECITIZEN” (for example: AB3ECITIZEN → code is AB3).", "Return here and enter that 3-character code.", "Once successfully verified, your full transaction will be processed and the small verification amount will be refunded."];
      }
    },
    refundMessage: {
      type: String,
      default: "The verification charge will be refunded within 3-5 business days."
    },
    showAttemptsRemaining: {
      type: Boolean,
      default: false
    },
    showSuccessAlert: {
      type: Boolean,
      default: false
    },
    showErrorAlert: {
      type: Boolean,
      default: false
    },
    maxAttempts: {
      type: Number,
      default: 3
    }
  },
  data: function data() {
    return {
      amount: "",
      code: "",
      amountError: "",
      codeError: "",
      numberOfAttempts: 0
    };
  },

  computed: {
    isMaxAttemptsReached: function isMaxAttemptsReached() {
      return this.numberOfAttempts >= this.maxAttempts;
    },
    inputClass: function inputClass() {
      if (this.showErrorAlert) {
        return "border-red-500";
      }
      if (this.showSuccessAlert) {
        return "border-green-500";
      }
      return "border-gray-300";
    }
  },
  methods: {
    handleComeBackLater: function handleComeBackLater() {
      this.$emit("comeBackLater");
    },
    handleTryDifferentCard: function handleTryDifferentCard() {
      this.$emit("voidProfileVerification");
    },
    validateAmount: function validateAmount() {
      var trimmed = this.amount.toString().trim();

      this.amount = trimmed;

      if (!trimmed) {
        this.amountError = "Amount is required";
      } else if (!/^\d+(\.\d+)?$/.test(trimmed)) {
        this.amountError = "Amount must be a valid number";
      } else {
        this.amountError = "";
      }
    },
    validateCode: function validateCode() {
      var trimmed = this.code.toString().trim();

      this.code = trimmed;

      if (!trimmed) {
        this.codeError = "This field is required";
      } else {
        this.codeError = "";
      }
    },
    onSubmit: function onSubmit() {
      this.validateCode();

      if (this.codeError) {
        return;
      }
      this.$emit("codeVerification", {
        code: this.code,
        isMaxAttemptsReached: this.isMaxAttemptsReached
      });
      this.numberOfAttempts++;
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"grid grid-cols-12 gap-6",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"col-span-full lg:col-span-7 flex flex-col gap-8"},[_c('div',{staticClass:"flex flex-col gap-3"},[_c('h2',{staticClass:"text-[#4c4f59] text-base font-semibold leading-normal text-left"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")]),_vm._v(" "),_c('p',{staticClass:"text-black/80 text-xs font-medium leading-tight text-left"},[_vm._v("\n        "+_vm._s(_vm.subtitle)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col gap-1"},[_c('label',{staticClass:"text-[#344053] text-sm font-medium leading-normal",attrs:{"for":"code"}},[_vm._v("\n        "+_vm._s(_vm.inputLabel)+"\n      ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"border border-red-500 rounded-lg px-4 py-2 text-sm text-black/80 focus:outline-none card-input mx-px",attrs:{"id":"code","type":"text","required":""},domProps:{"value":(_vm.code)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.code=$event.target.value},_vm.validateCode]}}),_vm._v(" "),(_vm.codeError)?_c('form-error',{attrs:{"message":_vm.codeError}}):_vm._e(),_vm._v(" "),_c('p',{staticClass:"text-red-600 text-xs mt-1"},[_vm._v("\n        Attempts remaining: "+_vm._s(_vm.maxAttempts - _vm.numberOfAttempts)+" of\n        "+_vm._s(_vm.maxAttempts)+"\n      ")])],1),_vm._v(" "),(_vm.showErrorAlert)?_c('div',{staticClass:"bg-[#ffefef] rounded-lg p-3 flex items-start gap-2 text-[#bc252b]"},[_c('svg',{staticClass:"w-5 h-5 mt-0.5",attrs:{"width":"19","height":"18","viewBox":"0 0 19 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M17.5668 13.2187L11.043 2.53117C10.8868 2.27413 10.6618 2.06063 10.3908 1.91217C10.1198 1.76371 9.81228 1.68555 9.49921 1.68555C9.18615 1.68555 8.87862 1.76371 8.6076 1.91217C8.33658 2.06063 8.11165 2.27413 7.95546 2.53117L1.43164 13.2187C1.27316 13.4744 1.18893 13.7653 1.18752 14.0619C1.1861 14.3584 1.26755 14.65 1.42359 14.9071C1.57962 15.1642 1.80469 15.3776 2.07593 15.5256C2.34718 15.6736 2.65494 15.751 2.96796 15.7499H16.0305C16.3435 15.751 16.6513 15.6736 16.9225 15.5256C17.1937 15.3776 17.4188 15.1642 17.5748 14.9071C17.7309 14.65 17.8123 14.3584 17.8109 14.0619C17.8095 13.7653 17.7253 13.4744 17.5668 13.2187ZM8.90546 7.31242C8.90546 7.16324 8.96802 7.02016 9.07937 6.91468C9.19072 6.80919 9.34174 6.74992 9.49921 6.74992C9.65669 6.74992 9.80771 6.80919 9.91906 6.91468C10.0304 7.02016 10.093 7.16324 10.093 7.31242V10.1249C10.093 10.2741 10.0304 10.4172 9.91906 10.5227C9.80771 10.6282 9.65669 10.6874 9.49921 10.6874C9.34174 10.6874 9.19072 10.6282 9.07937 10.5227C8.96802 10.4172 8.90546 10.2741 8.90546 10.1249V7.31242ZM9.49921 13.4999C9.32306 13.4999 9.15087 13.4504 9.00441 13.3577C8.85795 13.265 8.74379 13.1332 8.67638 12.9791C8.60897 12.8249 8.59134 12.6552 8.6257 12.4916C8.66007 12.3279 8.74489 12.1776 8.86945 12.0596C8.994 11.9416 9.1527 11.8612 9.32546 11.8286C9.49823 11.7961 9.6773 11.8128 9.84004 11.8767C10.0028 11.9405 10.1419 12.0487 10.2397 12.1874C10.3376 12.3262 10.3898 12.4893 10.3898 12.6562C10.3898 12.8799 10.296 13.0946 10.129 13.2528C9.96196 13.411 9.73542 13.4999 9.49921 13.4999Z","fill":"#BC252B"}})]),_vm._v(" "),_c('div',{staticClass:"flex flex-col gap-1"},[_c('p',{staticClass:"text-sm font-semibold"},[_vm._v(_vm._s(_vm.errorTitle))]),_vm._v(" "),_c('p',{staticClass:"text-xs"},[_vm._v("\n          "+_vm._s(_vm.errorMessage)+"\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.showSuccessAlert)?_c('div',{staticClass:"bg-[#E0FFEF] rounded-lg p-3 flex items-start gap-2 text-[#4C4F59]"},[_c('svg',{attrs:{"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"1","y":"1.5","width":"18","height":"18","rx":"9","fill":"#009247","stroke":"#009247","stroke-width":"2"}}),_vm._v(" "),_c('path',{attrs:{"d":"M5.33398 11.1667L8.00065 13.8334L14.6673 7.16675","stroke":"white","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})]),_vm._v(" "),_c('div',{staticClass:"text-sm"},[_c('p',{staticClass:"font-semibold"},[_vm._v("\n          "+_vm._s(_vm.successTitle)+"\n          "),_c('span',{staticClass:"font-normal"},[_vm._v(_vm._s(_vm.successSubtitle))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex gap-4 mt-6 lg:flex-row flex-col-reverse"},[_c('button',{staticClass:"px-5 flex-1 btn-outline",attrs:{"type":"button"},on:{"click":_vm.handleComeBackLater}},[_vm._v("\n        "+_vm._s(_vm.comeBackLaterText)+"\n      ")]),_vm._v(" "),_c('button',{staticClass:"px-5 flex-1 btn-primary",attrs:{"type":"submit","disabled":_vm.isMaxAttemptsReached}},[_vm._v("\n        "+_vm._s(_vm.verifyText)+"\n      ")])]),_vm._v(" "),_c('p',{staticClass:"text-center text-xs text-black/80 mt-4"},[_vm._v("\n      Still don’t see it?\n      "),_c('a',{staticClass:"hover:cursor-pointer text-[#3C65F5] font-medium",on:{"click":function($event){$event.preventDefault();return _vm.handleTryDifferentCard.apply(null, arguments)}}},[_vm._v("Try different Card")])])]),_vm._v(" "),_c('div',{staticClass:"col-span-full lg:col-span-5"},[_c('div',{staticClass:"p-4 bg-[#f7f8fc] w-full rounded-xl inline-flex flex-col items-start gap-2"},[_c('p',{staticClass:"text-black/80 text-sm font-semibold leading-[21px]"},[_vm._v("\n        "+_vm._s(_vm.tipsTitle)+"\n      ")]),_vm._v(" "),_c('ul',{staticClass:"text-black/80 text-xs font-medium leading-[18px] list-disc pl-4"},_vm._l((_vm.tips),function(tip,index){return _c('li',{key:index},[_vm._v(_vm._s(tip))])}),0),_vm._v(" "),_c('div',{staticClass:"bg-[#006FFF1A] rounded-lg p-3 flex items-start gap-2 text-[#5D5D5D]"},[_c('div',{staticClass:"size-5"},[_c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M9.99935 1.66675C5.40768 1.66675 1.66602 5.40841 1.66602 10.0001C1.66602 14.5917 5.40768 18.3334 9.99935 18.3334C14.591 18.3334 18.3327 14.5917 18.3327 10.0001C18.3327 5.40841 14.591 1.66675 9.99935 1.66675ZM9.37435 6.66675C9.37435 6.32508 9.65768 6.04175 9.99935 6.04175C10.341 6.04175 10.6243 6.32508 10.6243 6.66675V10.8334C10.6243 11.1751 10.341 11.4584 9.99935 11.4584C9.65768 11.4584 9.37435 11.1751 9.37435 10.8334V6.66675ZM10.766 13.6501C10.7243 13.7584 10.666 13.8417 10.591 13.9251C10.5077 14.0001 10.416 14.0584 10.316 14.1001C10.216 14.1417 10.1077 14.1667 9.99935 14.1667C9.89102 14.1667 9.78268 14.1417 9.68268 14.1001C9.58268 14.0584 9.49102 14.0001 9.40768 13.9251C9.33268 13.8417 9.27435 13.7584 9.23268 13.6501C9.19102 13.5501 9.16602 13.4417 9.16602 13.3334C9.16602 13.2251 9.19102 13.1167 9.23268 13.0167C9.27435 12.9167 9.33268 12.8251 9.40768 12.7417C9.49102 12.6667 9.58268 12.6084 9.68268 12.5667C9.88268 12.4834 10.116 12.4834 10.316 12.5667C10.416 12.6084 10.5077 12.6667 10.591 12.7417C10.666 12.8251 10.7243 12.9167 10.766 13.0167C10.8077 13.1167 10.8327 13.2251 10.8327 13.3334C10.8327 13.4417 10.8077 13.5501 10.766 13.6501Z","fill":"#3532EA"}})])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col gap-1"},[_c('p',{staticClass:"text-[10px] font-normal"},[_vm._v("\n            "+_vm._s(_vm.refundMessage)+"\n          ")])])])])])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-cf1edb84", __vue__options__)
  } else {
    hotAPI.reload("data-v-cf1edb84", __vue__options__)
  }
})()}